export const ShareIcon = ({ color }: { color?: string }) => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="wrapper">
			<path
				id="Vector"
				d="M19.25 11V15.8125C19.25 16.6948 18.5075 17.4167 17.6 17.4167H4.4C3.4925 17.4167 2.75 16.6948 2.75 15.8125V11"
				stroke="#0F0F0F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Vector_2"
				d="M14.6667 8.25C13.2347 6.81808 11 4.58333 11 4.58333L7.33333 8.25"
				stroke="#0F0F0F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				id="Vector_3"
				d="M11 5.50004L11 12.8334"
				stroke="#0F0F0F"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
